import ApiConstant from "../../../constants/api.constants";
import Helpers from "../../../utils/helpers";
import api from "../../api";
import RouteSummaryData from "./stable_data/route_summary.json";
const GetRouteSummary = async () => {
  return await api
    .get(process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA + '/api' + ApiConstant.getRoutesSummary)
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      return "error";
      // console.log(error);
    });


  // return await new Promise((resolve, reject) => {
    
  //   resolve(RouteSummaryData.data);
  // });
};
const RouteSummary = {
  GetRouteSummary,
};
export default RouteSummary;
